import { render, staticRenderFns } from "./new-room.vue?vue&type=template&id=4a0854ad&"
import script from "./new-room.vue?vue&type=script&lang=js&"
export * from "./new-room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports